import { useEffect, useState } from "react";
import { courtOwnerApi } from "../../api/courtOwnerApi";
import CourtOwnerSidebar from "../../components/courtowner/CourtOwnerSidebar";

export default function CourtOwnerProfile() {
  const [profile, setProfile] = useState(null);
  const [newMobile, setNewMobile] = useState("91");
  const [isEditing, setIsEditing] = useState(false);
  const [editForm, setEditForm] = useState({});
  const [isPrimary, setIsPrimary] = useState(true);

  useEffect(() => {
    loadProfile();
  }, []);

  const loadProfile = async () => {
    const data = await courtOwnerApi.getProfile();
    setProfile(data);
    setIsPrimary(data.isPrimary ?? true);

    setEditForm({
      name: data.name || "",
      businessName: data.businessName || "",
      address: data.address || "",
      email: data.email || "",
    });
  };

  const handleAddMobile = async () => {
    const res = await courtOwnerApi.addMobile({ newMobile });
    if (res.success) {
      setNewMobile("91");
      loadProfile();
    } else alert(res.error);
  };

  const handleRemoveMobile = async (m) => {
    const res = await courtOwnerApi.removeMobile({ mobileToRemove: m });
    if (res.success) loadProfile();
    else alert(res.error);
  };

  const handleSave = async () => {
    const res = await courtOwnerApi.updateProfile(editForm);
    if (res.success) {
      setIsEditing(false);
      loadProfile();
    } else alert(res.error);
  };

  if (!profile) return <div>Loading...</div>;

  return (
    <div className="min-h-screen flex bg-[#f3f6ff]">

      {/* SIDEBAR */}
      <CourtOwnerSidebar />

      {/* MOBILE HEADER */}
      <div className="lg:hidden fixed top-0 left-0 w-full bg-[#0f2250] text-white py-4 px-5 shadow-md z-30">
        <h1 className="text-xl font-semibold text-left ms-10">My Profile</h1>
      </div>

      {/* MAIN */}
      <div className="flex-1 px-4 sm:px-6 lg:px-10 py-6 mt-16 lg:mt-0 lg:ml-[260px]">

  <div className="max-w-3xl mx-auto">

    {/* === PROFILE CARD === */}
    <div className="bg-white rounded-3xl shadow-[0_4px_15px_rgba(0,0,0,0.06)] p-6 border border-gray-100">
      
      {/* Header */}
      {/* <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-extrabold text-[#0d2149] tracking-tight">
          Account Details
        </h2>

<div className="mb-4">
  <label className="text-gray-500 text-xs uppercase tracking-wide font-semibold">
    Unique Owner ID
  </label>

  <p className="text-[17px] font-bold mt-1 text-[#0d2149]">
    {profile.uniqueId || (
      <span className="text-gray-400 font-normal">Not assigned</span>
    )}
  </p>
</div>

        {!isEditing && (
          <button
            className="bg-[#0d2149] hover:bg-[#152f63] active:scale-95 transition px-5 py-2.5 rounded-xl text-white font-medium shadow-sm"
            onClick={() => setIsEditing(true)}
          >
            Edit
          </button>
        )}
      </div> */}
{/* Header */}
<div className="flex justify-between items-center mb-4">
  <h2 className="text-2xl font-extrabold text-[#0d2149] tracking-tight">
    Account Details
  </h2>

  {!isEditing && (
    <button
      className="bg-[#0d2149] hover:bg-[#152f63] active:scale-95 transition px-5 py-2.5 rounded-xl text-white font-medium shadow-sm"
      onClick={() => setIsEditing(true)}
    >
      Edit
    </button>
  )}
</div>

{/* Unique ID */}
<div className="mb-4">
  <label className="text-gray-500 text-xs uppercase tracking-wide font-semibold">
    Unique Owner ID
  </label>

  <p className="text-[17px] font-bold mt-1 text-[#0d2149]">
    {profile.uniqueId || (
      <span className="text-gray-400 font-normal">Not assigned</span>
    )}
  </p>
</div>

      {/* Inputs Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 ">
        {["name", "businessName", "email", "address"].map((field) => (
          <div key={field}>
            <label className="text-gray-500 text-xs uppercase tracking-wide font-semibold">
              {field.replace(/([A-Z])/g, " $1")}
            </label>

            {!isEditing ? (
              <p className="text-[17px] font-semibold mt-1 text-gray-900">
                {profile[field] || (
                  <span className="text-gray-400 font-normal">Not added</span>
                )}
              </p>
            ) : (
              <input
                value={editForm[field] || ""}
                onChange={(e) =>
                  setEditForm({ ...editForm, [field]: e.target.value })
                }
                className="border rounded-lg p-3 w-full mt-1 text-gray-800 focus:ring-2 focus:ring-[#0d2149] focus:border-[#0d2149] transition-all"
              />
            )}
          </div>
        ))}

        {/* Primary Mobile */}
        <div>
          <label className="text-gray-500 text-xs uppercase tracking-wide font-semibold">
            Primary Mobile
          </label>
          <p className="text-[17px] font-semibold mt-1 text-gray-900">
            {profile.mobile}
          </p>
        </div>
      </div>

      {/* Save/Cancel */}
      {isEditing && (
        <div className="flex gap-3 mt-8">
          <button
            className="bg-green-600 hover:bg-green-700 active:scale-95 transition text-white px-5 py-2.5 rounded-xl font-medium shadow-sm"
            onClick={handleSave}
          >
            Save
          </button>
          <button
            className="bg-gray-300 hover:bg-gray-400 active:scale-95 transition text-gray-800 px-5 py-2.5 rounded-xl font-medium"
            onClick={() => setIsEditing(false)}
          >
            Cancel
          </button>
        </div>
      )}
    </div>

    {/* === ADDITIONAL MOBILES === */}
    <div className="bg-white rounded-3xl shadow-[0_4px_15px_rgba(0,0,0,0.06)] p-6 border border-gray-100 mt-7">

      <h3 className="text-xl font-extrabold text-[#0d2149] tracking-tight mb-2">
        Additional Login Mobiles
      </h3>

      {isPrimary ? (
        <>
          {/* List of mobiles */}
          <div className="flex flex-wrap gap-3 mt-3">
            {(profile.additionalMobiles || []).map((m, i) => (
              <div
                key={i}
                className="bg-blue-50 border border-blue-200 text-blue-800 px-4 py-1.5 rounded-full flex items-center gap-3 shadow-sm"
              >
                {m}
                <button
                  onClick={() => handleRemoveMobile(m)}
                  className="text-red-600 hover:text-red-800 font-bold text-lg leading-none"
                >
                  ×
                </button>
              </div>
            ))}
          </div>

          {/* Add new */}
          <div className="mt-5 flex flex-col sm:flex-row gap-3">
            <input
              value={newMobile}
              onChange={(e) => setNewMobile(e.target.value)}
              className="border rounded-xl p-3 flex-1 focus:ring-2 focus:ring-[#0d2149] focus:border-[#0d2149] transition-all"
              placeholder="91XXXXXXXXXX"
            />

            <button
              onClick={handleAddMobile}
              className="bg-green-600 hover:bg-green-700 active:scale-95 transition text-white px-6 py-3 rounded-xl font-medium whitespace-nowrap shadow-sm"
            >
              + Add Mobile
            </button>
          </div>
        </>
      ) : (
        <p className="text-sm text-gray-600 mt-2">
          Only the primary owner can manage additional mobiles.
        </p>
      )}
    </div>
  </div>
</div>

    </div>
  );
}
